import React from 'react';
import MainLayout from '../layouts/MainLayout';

const AboutPage: React.FC = () => {
  return (
    <MainLayout>
      <div className="page-banner">
        <div className="container">
          <h1>About Fallen Leaf Lodge</h1>
          <p>Serving visitors since 1908</p>
        </div>
      </div>

      <section className="about-section">
        <div className="container">
          <div className="history-section">
            <div className="image-col">
              <img src="/images/lodge-history.jpg" alt="Historic Fallen Leaf Lodge" />
            </div>
            <div className="text-col">
              <h2>Our Story</h2>
              <p>Fallen Leaf Lodge has a rich history that dates back to the early 1900s. Established in 1908, the lodge began as a small fishing camp catering to adventurous souls looking to explore the pristine waters of Fallen Leaf Lake and the surrounding Sierra Nevada mountains.</p>
              <p>Over the decades, the lodge has evolved from its humble beginnings into a beloved destination for generations of families, outdoor enthusiasts, and those seeking a more authentic Tahoe experience away from the crowds.</p>
              <p>Today, Fallen Leaf Lodge continues to provide that same warm hospitality and access to the natural beauty that has defined us for over a century, while offering modern amenities and services to enhance your stay.</p>
            </div>
          </div>

          <div className="timeline-section">
            <h2 className="section-title">Our Journey Through Time</h2>
            <div className="timeline-container">
              <div className="timeline-item">
                <div className="year">1908</div>
                <div className="content">
                  <h3>The Beginning</h3>
                  <p>Fallen Leaf Lodge was first established as a small fishing camp catering to adventurous souls looking to explore the pristine waters and surrounding Sierra Nevada mountains.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="year">1920s</div>
                <div className="content">
                  <h3>Expansion</h3>
                  <p>As word spread about our unique location and hospitality, we expanded our facilities to include more accommodations and began offering guided fishing expeditions.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="year">1950s</div>
                <div className="content">
                  <h3>Post War Growth</h3>
                  <p>Following World War II, families began returning to Fallen Leaf Lake. We enhanced our facilities and introduced new recreational activities to meet the growing demand.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="year">1970s</div>
                <div className="content">
                  <h3>New Ownership</h3>
                  <p>The lodge underwent a careful renovation under new stewardship, preserving its historic character while modernizing essential amenities for guest comfort.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="year">1990s</div>
                <div className="content">
                  <h3>Modern Marina</h3>
                  <p>Our marina facilities were completely renovated with modern slips, fuel services, and a comprehensive boat rental program, making us a premier destination for water enthusiasts.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="year">2010s</div>
                <div className="content">
                  <h3>Renovation</h3>
                  <p>Major renovations brought modern amenities to our cafe and general store while maintaining the rustic charm that has defined Fallen Leaf Lodge for over a century.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mission-section">
            <h2>Our Mission</h2>
            <p>At Fallen Leaf Lodge, our mission is to preserve the natural beauty and history of Fallen Leaf Lake while providing visitors with authentic experiences that connect them to the environment, the community, and each other.</p>
            <p>We strive to:</p>
            <ul>
              <li>Promote responsible recreation and environmental stewardship</li>
              <li>Support the local community through sustainable business practices</li>
              <li>Create memorable experiences for visitors of all ages</li>
              <li>Maintain the historic character and charm of the lodge while offering modern amenities</li>
            </ul>
          </div>

          <div className="team-section">
            <h2>Meet Our Team</h2>
            <div className="team-grid">
              <div className="team-member">
                <img src="/images/team/john-smith.jpg" alt="John Smith" />
                <h3>John Smith</h3>
                <p className="title">General Manager</p>
                <p>With over 15 years of experience in hospitality and a deep love for the Tahoe area, John oversees all operations at Fallen Leaf Lodge.</p>
              </div>
              
              <div className="team-member">
                <img src="/images/team/sarah-johnson.jpg" alt="Sarah Johnson" />
                <h3>Sarah Johnson</h3>
                <p className="title">Marina Director</p>
                <p>Sarah is a certified boat captain and outdoor enthusiast who ensures our marina operations run smoothly and safely.</p>
              </div>
              
              <div className="team-member">
                <img src="/images/team/michael-chen.jpg" alt="Michael Chen" />
                <h3>Michael Chen</h3>
                <p className="title">Head Chef</p>
                <p>Chef Michael brings his culinary expertise to our cafe, creating delicious meals with locally-sourced ingredients.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <h2>Come Experience Fallen Leaf Lake</h2>
          <p>Visit us and discover why families have been returning to our lodge for generations</p>
          <div className="buttons">
            <a href="/marina" className="btn primary">Explore Marina Services</a>
            <a href="/contact" className="btn secondary">Contact Us</a>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default AboutPage; 